// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__RoABv","image":"Header_image__z9VlK","name":"Header_name__tlci5","info":"Header_info__1O6LH","infoRow":"Header_infoRow__3-kUA"};